import { createSelector } from "reselect";
export const getRouterState = (state) => state.router;
export const currentLocationSelector = createSelector(getRouterState, (state) => state.location);
